/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.Egifts {

    export class EgiftCheckCurrencyMinValue implements angular.IDirective {
        restrict = "A";
        require = ['ngModel', '^form'];
        link = (scope: any, element: JQuery, attrs: any, ctrl: [angular.INgModelController, angular.IFormController]) => {
            if (angular.isUndefined(attrs.minValue)) return;

            const modelCtrl = ctrl[0];
            const formCtrl = ctrl[1];

            scope.$watch(attrs.ngModel, (newVal, oldVal) => {
                if (newVal === oldVal) return;

                if (Number(modelCtrl.$viewValue) >= Number(scope.$eval(attrs.minValue)) && formCtrl[attrs.name]) {
                    formCtrl[attrs.name].$setValidity('lessThenPreviousAmount', true);
                }
            });

            scope.$watch(attrs.minValue, (newVal, oldVal) => {
                if (newVal === oldVal || !formCtrl[attrs.name]) return;

                formCtrl[attrs.name].$setValidity('lessThenPreviousAmount', true);
                if (Number(newVal) > Number(modelCtrl.$viewValue)) {
                    formCtrl[attrs.name].$setValidity('lessThenPreviousAmount', false);
                }
            });
        };

        constructor() { }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new EgiftCheckCurrencyMinValue();
            };
            directive.$inject = [];

            return directive;
        }
    }

    angular.module('meevo.plugins.egifts')
        .directive('egiftCheckCurrencyMinValue', EgiftCheckCurrencyMinValue.factory());
}
